var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1141,
    height: 400,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1130 0H10C4.477 0 0 4.477 0 10v380c0 5.523 4.477 10 10 10h1120c5.52 0 10-4.477 10-10V10c0-5.523-4.48-10-10-10z",
    fill: "url(#paint0_linear_4955_118)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340 297.312L173.817 130.936l-19.23 15.758L107.946 100 0 188.457V300l82.567-.862V300L340 297.312z",
    fill: "url(#paint1_linear_4955_118)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 300h1140v90c0 5.523-4.48 10-10 10H10c-5.523 0-10-4.477-10-10v-90z",
    fill: "url(#paint2_linear_4955_118)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.429 320.653L0 389.633V333.14l405.429-12.487z",
    fill: "url(#paint3_linear_4955_118)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M790 300h350V99.685L1100.24 70 790 300z",
    fill: "url(#paint4_linear_4955_118)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M272 300l207.231-150L685 300H272z",
    fill: "url(#paint5_linear_4955_118)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M687.19 37l71.569 52.923 22.182-16.29L1087 300l-44.15-.001V300H329L687.19 37z",
    fill: "url(#paint6_linear_4955_118)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.189 149c17.89 0 26.953 3.958 26.53 10.11l-.016.188H22C43.063 153.038 66.118 149 84.189 149zm946.001-49c18.07 0 27.13 4.038 26.51 10.298H968c21.062-6.26 44.12-10.298 62.19-10.298zM694.63 86c33.553 0 50.549 7.424 49.755 18.963l-.029.351H578c.019-.005.038-.01.057-.017H495C516.063 99.039 539.118 95 557.189 95c16.455 0 25.442 3.349 26.448 8.674C621.577 92.874 662.345 86 694.631 86h-.001zm445.47-66v31.723H954c62.77-18.653 131.26-30.91 186.1-31.723zm-928.47 6c33.553 0 50.549 7.424 49.755 18.963l-.03.351H95l.054-.016H13C34.062 39.039 57.118 35 75.189 35c16.178 0 25.137 3.237 26.39 8.407C139.25 32.761 179.612 26 211.632 26h-.002z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1024.5 128l8.46 52.394 78.96-9.142L1118.5 130l6.34 39.755L1140 168v132H0l457.318-52.953L461 236l3.409 10.226 41.594-4.816L511 210l4.816 30.274 46.657-5.402L568.5 198l5.803 35.502 4.518-.523 7.68-46.979 7.393 45.234 129.542-15L731.501 167l7.763 47.401 254.983-29.524L999 155l4.58 28.796 12.13-1.405L1024.5 128z",
    fill: "url(#paint7_linear_4955_118)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1051.52 226l9.31 49.157 57.44-6.643 4.75-23.514 4.54 22.439L1140 266l.1 50.22-400.1-3.958 236.177-27.315L981.523 258l5.106 25.739 34.721-4.016 8.67-45.723 8.3 43.76 3.48-.402 9.72-51.358z",
    fill: "url(#paint8_linear_4955_118)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67 223l9.003 63.019 63.253 6.675L143.249 281l4.29 12.568 49.765 5.252 4.944-35.82 5.089 36.879 74.318 7.843L285.758 278l4.223 30.6 116.129 12.256L0 333.065V278l58.265 6.147L67.001 223H67z",
    fill: "url(#paint9_linear_4955_118)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.83 285.805l-21.405 11.829h6.768L0 332.967v-9.53l48.736-39.736 27.094 2.104z",
    fill: "url(#paint10_linear_4955_118)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M137.146 297.88l-82.569 33.388-9.577.395 60.34-33.783h31.806z",
    fill: "url(#paint11_linear_4955_118)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M303 360.5h100m52-15.518h50M170 358.5h20m355 13h50m-25-33.105h30m-326 6h50M191 371.5h50",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M911 371.5h80m16-11h30m-78-16h50m-236 0h50",
    stroke: "#98DCB8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.521 239L206 313.668h15.042L213.521 239z",
    fill: "#0A6849"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 208l-15 90h30l-15-90z",
    fill: "url(#paint12_linear_4955_118)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M129.5 253l-7.5 45h15l-7.5-45z",
    fill: "url(#paint13_linear_4955_118)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.5 233L102 301h23l-11.5-68z",
    fill: "url(#paint14_linear_4955_118)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5 247L13 290h15l-7.5-43z",
    fill: "url(#paint15_linear_4955_118)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.59 290L0 311.967v-5.987L13.052 290H27.59z",
    fill: "url(#paint16_linear_4955_118)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.961 299.869L160 323.424 197.715 299l10.246.869z",
    fill: "url(#paint17_linear_4955_118)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M289.98 308.644l-32.066 16.528 23.725-17.452 8.341.924z",
    fill: "url(#paint18_linear_4955_118)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.059 313.704l-30.352 13.485-8.746.39 24.246-14.345 14.852.47z",
    fill: "url(#paint19_linear_4955_118)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4955_118",
    x1: 570,
    y1: 112.64,
    x2: 554.858,
    y2: 217.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFDFDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFDB",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4955_118",
    x1: -21.502,
    y1: 89.896,
    x2: 69.751,
    y2: 272.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CD93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98DCB8",
    stopOpacity: 0.344
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4955_118",
    x1: 435.571,
    y1: 400,
    x2: 435.571,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D2FEE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F8FFFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4955_118",
    x1: 292.801,
    y1: 355.005,
    x2: 235.901,
    y2: 299.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98DCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEFDF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4955_118",
    x1: 1265.86,
    y1: 55.108,
    x2: 1124.62,
    y2: 245.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CD93",
    stopOpacity: 0.487
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98DCB8",
    stopOpacity: 0.216
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4955_118",
    x1: 570.595,
    y1: 198.147,
    x2: 523.466,
    y2: 284.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98DCB8",
    stopOpacity: 0.413
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEFDF5",
    stopOpacity: 0.491
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4955_118",
    x1: 1151.16,
    y1: 82.157,
    x2: 940.091,
    y2: 387.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42CD93",
    stopOpacity: 0.683
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#98DCB8",
    stopOpacity: 0.215
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4955_118",
    x1: 1110.25,
    y1: 212.507,
    x2: -16.791,
    y2: 369.346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98DCB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEFDF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_4955_118",
    x1: 1026.43,
    y1: 265.993,
    x2: 1028.19,
    y2: 279.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4955_118",
    x1: -137.915,
    y1: 282.578,
    x2: 368.427,
    y2: 246.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4955_118",
    x1: -4.904,
    y1: 318.732,
    x2: 226.448,
    y2: 146.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4955_118",
    x1: 48.867,
    y1: 318.225,
    x2: 292.939,
    y2: 133.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4955_118",
    x1: 43.822,
    y1: 229.409,
    x2: 84.883,
    y2: 314.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_4955_118",
    x1: 128.667,
    y1: 265.422,
    x2: 144.872,
    y2: 301.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_4955_118",
    x1: 112.184,
    y1: 258.562,
    x2: 136.981,
    y2: 307.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_4955_118",
    x1: 19.295,
    y1: 255.024,
    x2: 40.381,
    y2: 299.337,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_4955_118",
    x1: -3.774,
    y1: 309.644,
    x2: 78.777,
    y2: 206.118,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_4955_118",
    x1: 160,
    y1: 317.266,
    x2: 262,
    y2: 253.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_4955_118",
    x1: 249.463,
    y1: 321.52,
    x2: 310.381,
    y2: 291.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_4955_118",
    x1: 146.96,
    y1: 323.598,
    x2: 313.658,
    y2: 263.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0A6849"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D8B67"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack);
export default __webpack_public_path__ + "static/media/back.91df787c1c3d85fa55629cf0a78872cb.svg";
export { ForwardRef as ReactComponent };